import { render } from "./InputFoto.vue?vue&type=template&id=00a723bc&scoped=true"
import script from "./InputFoto.vue?vue&type=script&lang=js"
export * from "./InputFoto.vue?vue&type=script&lang=js"

import "./InputFoto.vue?vue&type=style&index=0&id=00a723bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a723bc"]])

export default __exports__